exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!../../assets/typography.pcss"), undefined);

// module
exports.push([module.id, ".BackToTop__caret___1YZwW{transform:rotate(180deg);display:inline-block;margin-left:2px}.BackToTop__caret___1YZwW svg{width:1.5em;height:1.5em}.BackToTop__backtotop___1r1lf{//float:right;margin-top:48px}.BackToTop__backtotop___1r1lf a:hover{color:#004f5c}.BackToTop__backtotoptext___1xJrV{font-size:13px;display:inline-block;color:#004f5c;text-transform:uppercase;cursor:pointer}", ""]);

// exports
exports.locals = {
	"caret": "BackToTop__caret___1YZwW",
	"backtotop": "BackToTop__backtotop___1r1lf",
	"backtotoptext": "BackToTop__backtotoptext___1xJrV " + require("-!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!../../assets/typography.pcss").locals["bodyText"] + ""
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./src/client/assets/BackToTop/BackToTop.pcss
// module id = 863
// module chunks = 0